import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

// Shown every time the menu is opened (no "once per session" memory) — the
// customer taps/clicks anywhere to dismiss it and see the menu. Each theme
// supplies its own colors, tagline, and an optional decorative element;
// this component owns the shared layout/animation/dismiss behavior.
const MenuSplash = ({
  restaurantName,
  profileImage,
  backgroundColor,
  accentColor,
  tagline,
  Decoration,
  titleFont = "",
}) => {
  const reduceMotion = useReducedMotion();
  const [visible, setVisible] = useState(true);
  const dismiss = () => setVisible(false);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          role="button"
          tabIndex={0}
          aria-label={`ورود به منوی ${restaurantName || ""}؛ برای ادامه کلیک کنید`}
          onClick={dismiss}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              dismiss();
            }
          }}
          className="fixed inset-0 z-[60] flex cursor-pointer flex-col items-center justify-center overflow-hidden focus:outline-none"
          style={{ backgroundColor }}
          initial={{ opacity: 1 }}
          exit={reduceMotion ? { opacity: 0 } : { opacity: 0, scale: 1.03 }}
          transition={{ duration: 0.45, ease: "easeInOut" }}
        >
          {Decoration && (
            <>
              <Decoration className="absolute -right-3 -top-2 h-24 w-16 text-white/10" />
              <Decoration className="absolute -bottom-4 -left-2 h-28 w-20 rotate-180 text-white/10" />
            </>
          )}

          <motion.div
            initial={reduceMotion ? false : { opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-full border-4 border-white/20 bg-white/10"
          >
            {profileImage && <img src={profileImage} alt="" className="h-full w-full object-cover" />}
          </motion.div>

          <motion.h1
            initial={reduceMotion ? false : { opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.15, ease: "easeOut" }}
            className={`mt-4 text-2xl font-black tracking-wide text-white ${titleFont}`}
          >
            {restaurantName}
          </motion.h1>

          {tagline && (
            <motion.p
              initial={reduceMotion ? false : { opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="mt-2 text-xs font-bold tracking-[0.2em]"
              style={{ color: accentColor }}
            >
              {tagline}
            </motion.p>
          )}

          <motion.p
            initial={reduceMotion ? false : { opacity: 0 }}
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={reduceMotion ? { duration: 0.5, delay: 0.5 } : { duration: 1.8, delay: 0.6, repeat: Infinity, ease: "easeInOut" }}
            className="absolute bottom-10 text-xs font-bold text-white/80"
          >
            برای مشاهده منو ضربه بزنید
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MenuSplash;
